import { render, staticRenderFns } from "./AllocationChartSummary.vue?vue&type=template&id=2f0fd3b6&scoped=true"
import script from "./AllocationChartSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./AllocationChartSummary.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AllocationChartSummary.vue?vue&type=style&index=0&id=2f0fd3b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0fd3b6",
  null
  
)

export default component.exports